import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from 'primeng/accordion';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DataViewModule } from 'primeng/dataview';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SplitterModule } from 'primeng/splitter';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToolbarModule } from 'primeng/toolbar';
import { TooltipModule } from 'primeng/tooltip';
import { TreeModule } from 'primeng/tree';
import { AppSharedModule } from "../../shared/shared.module";
import { DocumentTypeDocClassComponent } from './document-type-item/doc-class/doc-class.component';
import { DocumentTypeCommonComponent } from './document-type-item/document-type-common.component';
import { DocumentTypeItemComponent } from './document-type-item/document-type-item.component';
import { ElynkPacketAddComponent } from './document-type-item/elynk-packet-add/elynk-packet-add.component';
import { ElynkPacketChecklistComponent } from './document-type-item/elynk-packet-checklist/elynk-packet-checklist.component';
import { ElynkPacketSelectComponent } from './document-type-item/elynk-packet-select/elynk-packet-select.component';
import { ElynkComponent } from './document-type-item/elynk/elynk.component';
import { TemplateMgrComponent } from './document-type-item/template-mgr/template-mgr.component';
import { DocumentTypeManagerRoutingModule } from './document-types-routing.module';
import { DocumentTypeManagerComponent } from './document-types.component';
@NgModule({
    declarations: [
        DocumentTypeManagerComponent,
        DocumentTypeCommonComponent,
        DocumentTypeItemComponent,
        ElynkPacketChecklistComponent,
        ElynkPacketSelectComponent,
        ElynkPacketAddComponent,
        DocumentTypeDocClassComponent,
        TemplateMgrComponent,
        ElynkComponent,
    ],
    imports: [
        AccordionModule,
        BlockUIModule,
        ButtonModule,
        CardModule,
        CheckboxModule,
        CommonModule,
        DialogModule,
        DividerModule,
        DocumentTypeManagerRoutingModule,
        DropdownModule,
        InputMaskModule,
        InputNumberModule,
        SelectButtonModule,
        SplitterModule,
        TableModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        InputTextModule,
        TabViewModule,
        DataViewModule,
        AppSharedModule,
        FormsModule,
        ReactiveFormsModule,
    ],
})
export class DocumentTypesManagerModule { }
